import {SidebarLanguages as LanguagesComponent} from '@github-ui/code-view-sidebar/components/SidebarLanguages'
import {isCombinedSidebarPayloadEnabled} from '@github-ui/code-view-sidebar/is-enabled'
import type {SidebarLanguagesResponse} from '@github-ui/code-view-sidebar/types'
import {useCombinedSidebarPayload} from '@github-ui/code-view-sidebar/use-combined-sidebar-payload'
import {useSuspenseQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface Props {
  ownerLogin: string
  repoName: string
}

export function SidebarLanguages(props: Props) {
  return isCombinedSidebarPayloadEnabled() ? (
    <SidebarLanguagesCombined {...props} />
  ) : (
    <SidebarLanguagesIndividual {...props} />
  )
}

function SidebarLanguagesCombined({ownerLogin, repoName}: Props) {
  const {languages} = useCombinedSidebarPayload(ownerLogin, repoName)
  if (!languages) return null
  return <LanguagesComponent {...languages} />
}

function SidebarLanguagesIndividual({ownerLogin, repoName}: Props) {
  const {data} = useSuspenseQuery({
    queryKey: ['code-view-sidebar', 'languages', {ownerLogin, repoName}],
    queryFn: async () => {
      const r = await verifiedFetchJSON(`/${ownerLogin}/${repoName}/_sidebar/languages`)
      if (!r.ok) throw new Error(`Sidebar languages fetch failed (${r.status})`)
      return (await r.json()) as SidebarLanguagesResponse
    },
  })

  if (!data) return null
  return <LanguagesComponent {...data} />
}
